import React, {Component} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {withRouter} from 'react-router-dom';
import md5 from 'md5';
import {RecentActivityStateless} from '@homeaway/react-recent-activity-carousel';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import {toURL} from '@homeaway/search-url-parser';
import {Waypoint} from '@homeaway/react-unveil';
import withAbacusTestValuesAsProps from '../../abacus/with-abacus-test-values-as-props';
import {withTranslationsAsProps} from '../../components/translations';
import {HA_PULSE_RECENT_ACTIVITY_TEST} from '../../abacus/experiments';
import TestExposureOnce from '../../abacus/test-exposure-once';
import {getSiteName} from '../../selectors/system';
import edap from '../edap'
import actions from '../actions';
import selectors from '../selectors';
import routes from '../../routes';
import './recent-activity-carousel-container.less';

export const testExposureCarousel = new TestExposureOnce(HA_PULSE_RECENT_ACTIVITY_TEST);


function mapStateToProps(state) {
    const fetchState = selectors.getFetchState(state);
    const cardIndex = selectors.getCardIndex(state);
    const summaries = selectors.getRecentActivityCarousel(state);
    const siteName = getSiteName(state);

    return {
        isEmpty: !summaries.length,
        isLoading: !fetchState.isFetched,
        siteName,
        summaries,
        cardIndex
    };
}

const mapDispatchToProps = {
    fetchRecentActivity: actions.fetchRecentActivity,
    changeRecentActivityCardIndex: actions.changeRecentActivityCardIndex
};

@withRouter
export class RecentActivityCarouselContainer extends Component {
    static defaultProps = {
        summaries: []
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.fetchRecentActivity();
    }

    handleArrowClick = (event, cardIndex) => {
        this.props.changeRecentActivityCardIndex({cardIndex});
    }

    handleCarouselClick = (e, scratchpadId, position, startDate, endDate, lbsUuid) => {
        if(this.props.recentActivityTestValue !== 1) {
            this.props.history.push(routes.RECENT_DETAILS.replace(':linkId', md5(scratchpadId)));
        }else{
            this.launchSearch(position, startDate, endDate, lbsUuid);
        }
    }

    launchSearch = (position, startDate, endDate, lbsUuid) => {
        const placeUrl = toURL({
            arrival: startDate,
            departure: endDate,
            searchTermUuid: encodeURIComponent(lbsUuid)
        });
        edap.recentActivitySearch(position, this.props.summaries.length, lbsUuid);
        window.open(placeUrl, this.props.isMobile ? '_self' : '_blank');
    }

    carouselExposure = () => {
        testExposureCarousel.trigger(HA_PULSE_RECENT_ACTIVITY_TEST);
    }

    getTitle = () => {
        const {recentActivityTestValue, title, altTitle} = this.props;
        return recentActivityTestValue !== 1 ? title : altTitle
    }

    render() {
        const {
            cardIndex,
            isLoading,
            isEmpty,
            isMobile,
            summaries,
            recentActivityTestValue
        } = this.props;
       
        if (isLoading || isEmpty) {
            return null;
        }
        
        return (
            <div className="recent-activity-summary__carousel">
                <Waypoint
                    label="waypoint-recent-activity-test-exposure"
                    onEnter={this.carouselExposure}
                >
                    {recentActivityTestValue !== 2 &&
                        <RecentActivityStateless
                            cardIndex={cardIndex}
                            isMobile={isMobile}
                            onArrowClick={this.handleArrowClick}
                            onClick={this.handleCarouselClick}
                            title={this.getTitle()}
                            summaries={summaries}
                        />
                    }
                </ Waypoint>
            </div>
        );
    }
}

export default compose(withAbacusTestValuesAsProps({
    [HA_PULSE_RECENT_ACTIVITY_TEST]: 'recentActivityTestValue',
}),
withTranslationsAsProps({
    'header.scratchpadSummary.messages.scratchpadActivity': 'title',
    'scratchpad.recentActivity.recentSearches': 'altTitle'
}),
connect(mapStateToProps, mapDispatchToProps))(determineIfMobile(RecentActivityCarouselContainer, 767));




// WEBPACK FOOTER //
// ./src/universal/recent-activity/components/recent-activity-carousel-container.js